import { useSelector } from 'react-redux'

import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors'

import YieldbirdNew from './YieldbirdNew'
import YieldbirdOld from './YieldbirdOld'

const Yieldbird = () => {
  const isUpdatedYieldBirdScriptEnabled = useSelector(
    getIsFeatureSwitchEnabled('web_ads_yieldbird_script_updated'),
  )

  return isUpdatedYieldBirdScriptEnabled ? <YieldbirdNew /> : <YieldbirdOld />
}

export default Yieldbird
